class Helper {
    public static printLoadingGrid(container: HTMLElement | null): void {
        if (!container) return;

        const loadingHTML = `
            <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                ${[...Array(6)].map(() => `
                <div class="animate-pulse bg-[#F8F9FA] rounded-3xl h-40 lg:h-115"></div>
                `).join('')}
            </div>
        `;
        container.innerHTML = loadingHTML;
    }
}
export default Helper;